// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__rKAbA","linksList":"Footer_linksList__Nvkyp","link":"Footer_link__F7bVr","active":"Footer_active__UutDZ"};